<nav [@animateMenu] class="navbar main-navbar on-top" [class.nav-shadow]='this.pageYPosition>0'>
    <div class="container">
        <a class="navbar-brand text-light">
            <img src='assets/images/logo.png' width='25' />
        </a>
        <ul ngbNav #nav="ngbNav" class="menu-ul">
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("about")'><span class='nav-number'>01. </span> <span class="underline nav-text">Acerca de mi</span></a>
                <ng-template ngbNavContent>First content</ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("jobs")'><span class='nav-number'>02. </span> <span class="underline nav-text">Experiencia</span></a>
                <ng-template ngbNavContent>Second content</ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("proyects")'><span class='nav-number'>03. </span> <span class="underline nav-text">Proyectos</span></a>
                <ng-template ngbNavContent>Second content</ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("more-proyects")'><span class='nav-number'>04. </span> <span class="underline nav-text">Estudios</span></a>
                <ng-template ngbNavContent>Second content</ng-template>
            </li>
            <li ngbNavItem>
                <a (click)="goToLogin()" class="main-btn cv-btn" ngbNavLink>
                  Login
                </a>
            </li>
        </ul>
        <div class="menu-wrapper">
            <div [class.animate]='responsiveMenuVisible' (click)='responsiveMenuVisible = !responsiveMenuVisible' class="hamburger-menu"></div>
        </div>
        <div class="menu-responsive" [ngStyle]="{'pointer-events': !responsiveMenuVisible ? 'none' : '' }">
            <aside [class.aside-show]='responsiveMenuVisible' [class.nav-shadow]='this.pageYPosition>0' class="on-top">
                <nav>
                    <ol>
                        <li>
                            <a (click)='scroll("about")'>
                                <span>01. </span> Acerca de mi
                            </a>
                        </li>
                        <li>
                            <a (click)='scroll("jobs")'>
                                <span>02. </span> Experiencia
                            </a>
                        </li>
                        <li>
                          <a (click)='scroll("proyects")'>
                              <span>03. </span> Proyectos
                          </a>
                      </li>
                      <li>
                        <a (click)='scroll("proyects")'>
                            <span>04. </span> Contacto
                        </a>
                      </li>


                    </ol>
                </nav>
            </aside>
        </div>
    </div>
</nav>
